import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Accordion, AccordionDetails, AccordionSummary, makeStyles } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useFormattingContext } from '../../../FormattingProvider/FormattingContext'
import { getCompletedValue, getField, getItemKey, getVisibleItems, TaskRow, useTaskRowStyles } from './shared'

const useAccordionStyles = makeStyles(() => ({
  accordion: {
    background: 'var(--color-neutral-50)',
    borderRadius: 'var(--border-radius-md) !important',
    boxShadow: 'none',
    border: 'var(--border-neutral-thin)',
    '&::before': { display: 'none' },
    '&.Mui-expanded': { margin: 0 }
  },
  summary: {
    fontSize: 'var(--font-size-sm)',
    fontWeight: 'var(--font-weight-medium)',
    color: 'var(--color-neutral-800)',
    minHeight: '40px !important',
    '& .MuiAccordionSummary-content': {
      margin: 'var(--dim-1) 0 !important'
    }
  }
}))

function TasksAccordion ({ data, displayConfig, isAdvisor }) {
  const rowClasses = useTaskRowStyles()
  const accordionClasses = useAccordionStyles()
  const { formatter } = useFormattingContext()
  const [expanded, setExpanded] = useState(false)

  const visibleItems = getVisibleItems(data, displayConfig, isAdvisor)
  if (!visibleItems.length) return null

  const completedValue = getCompletedValue(displayConfig)
  const completeCount = visibleItems.filter(i => getField(i, displayConfig, 'status') === completedValue).length
  const summaryLabel = displayConfig?.summaryLabel ?? 'tasks complete'
  const detailFields = displayConfig?.detailFields

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      className={accordionClasses.accordion}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={accordionClasses.summary}>
        {completeCount}/{visibleItems.length} {summaryLabel}
      </AccordionSummary>
      <AccordionDetails style={{ padding: '0 var(--dim-4) var(--dim-2)' }}>
        <ul className={rowClasses.list}>
          {visibleItems.map((item, idx) => (
            <TaskRow
              key={getItemKey(item, displayConfig, idx)}
              item={item}
              displayConfig={displayConfig}
              detailFields={detailFields}
              formatter={formatter}
              classes={rowClasses}
              completedValue={completedValue}
            />
          ))}
        </ul>
      </AccordionDetails>
    </Accordion>
  )
}

TasksAccordion.propTypes = {
  data: PropTypes.object,
  displayConfig: PropTypes.object,
  isAdvisor: PropTypes.bool
}

export default TasksAccordion
